// Teklif canlı ortak düzenleme: alan/kalem bazlı fark (diff), uygulama (apply) ve yerel değişiklikleri koruyan birleştirme (rebase)
export const LIVE_HEAD = ["customer_title", "customer_phone", "customer_address", "date", "valid_until", "kdv_rate", "global_discount_rate",
  "note", "payment_terms", "vat_exempt", "terms", "invoice_recipient_title", "invoice_recipient_vkn", "status", "stock_source"];
const ITEM_KEYS = ["name", "description", "code", "brand", "brand_off", "discount_group", "series", "quantity", "unit",
  "unit_price", "discount_rate", "cost", "product_id", "color", "mag_qty"];
const NUMS = new Set(["quantity", "unit_price", "discount_rate", "cost", "kdv_rate", "global_discount_rate", "mag_qty"]);

const norm = (k, v) => {
  if (NUMS.has(k)) return Number(v) || 0;
  if (k === "brand_off" || k === "vat_exempt") return !!v;
  if (k === "terms") return (Array.isArray(v) ? v : []).map((x) => String(x).trim()).filter(Boolean).join("\n");
  return v == null ? "" : String(v);
};
export const newUid = () => `${Date.now().toString(36)}${Math.random().toString(36).slice(2, 8)}`;
const isBlank = (it) => !String(it?.name || "").trim() && !it?.product_id;
const pick = (it) => { const o = { uid: it.uid }; ITEM_KEYS.forEach((k) => { if (it[k] !== undefined) o[k] = it[k]; }); return o; };

/** base (sunucudaki son hal) → cur (ekrandaki hal) farkı; fark yoksa null. Boş yeni satırlar gönderilmez. */
export function diffQuote(base, cur) {
  if (!base || !cur) return null;
  const set = {};
  LIVE_HEAD.forEach((k) => { if (norm(k, base[k]) !== norm(k, cur[k])) set[k] = cur[k]; });
  const bItems = base.items || [];
  const cItems = cur.items || [];
  const bm = new Map(bItems.map((it) => [it.uid, it]));
  const cm = new Map(cItems.map((it) => [it.uid, it]));
  const synced = (it) => bm.has(it.uid) || !isBlank(it);
  const del = bItems.filter((it) => !cm.has(it.uid)).map((it) => it.uid);
  const upd = {};
  const add = [];
  cItems.forEach((it, i) => {
    const b = bm.get(it.uid);
    if (!b) {
      if (isBlank(it)) return;
      let after = "";
      for (let j = i - 1; j >= 0; j -= 1) { if (synced(cItems[j])) { after = cItems[j].uid; break; } }
      add.push({ item: pick(it), after });
      return;
    }
    const f = {};
    ITEM_KEYS.forEach((k) => { if (norm(k, b[k]) !== norm(k, it[k])) f[k] = it[k]; });
    if (Object.keys(f).length) upd[it.uid] = f;
  });
  const bo = bItems.filter((it) => cm.has(it.uid)).map((it) => it.uid).join("|");
  const co = cItems.filter((it) => bm.has(it.uid)).map((it) => it.uid).join("|");
  const order = bo !== co ? cItems.filter(synced).map((it) => it.uid) : null;
  if (!Object.keys(set).length && !Object.keys(upd).length && !add.length && !del.length && !order) return null;
  return { set, upd, add, del, order };
}

export function applyQuoteOps(doc, ops) {
  if (!ops) return doc;
  let items = (doc.items || []).filter((it) => !ops.del.includes(it.uid)).map((it) => (ops.upd[it.uid] ? { ...it, ...ops.upd[it.uid] } : it));
  ops.add.forEach(({ item, after }) => {
    if (items.some((x) => x.uid === item.uid)) return;
    const idx = after ? items.findIndex((x) => x.uid === after) : -1;
    items.splice(after ? (idx >= 0 ? idx + 1 : items.length) : 0, 0, { ...item });
  });
  if (ops.order) {
    const pos = new Map(ops.order.map((u, n) => [u, n]));
    items = [...items.filter((x) => pos.has(x.uid)).sort((a, b) => pos.get(a.uid) - pos.get(b.uid)), ...items.filter((x) => !pos.has(x.uid))];
  }
  return { ...doc, ...ops.set, items };
}

/** Sunucudan gelen güncel teklif + henüz gönderilmemiş yerel değişiklikler (ops) → yeni ekran durumu.
 *  Değeri aynı olan alanlarda ekrandaki ham yazım korunur (ör. "1," yazılırken imleç/metin bozulmaz). */
export function rebase(remote, cur, ops, blankItem) {
  const m = applyQuoteOps(remote, ops);
  const cm = new Map((cur.items || []).map((it) => [it.uid, it]));
  const items = (m.items || []).map((it) => {
    const c = cm.get(it.uid);
    if (!c) return { ...blankItem(), ...it };
    const r = { ...c, ...it };
    ITEM_KEYS.forEach((k) => { if (norm(k, c[k]) === norm(k, it[k])) r[k] = c[k]; });
    return r;
  });
  const ids = new Set(items.map((x) => x.uid));
  (cur.items || []).forEach((it, i) => {
    if (ids.has(it.uid) || !isBlank(it)) return;
    let idx = 0;
    for (let j = i - 1; j >= 0; j -= 1) { const k = items.findIndex((x) => x.uid === cur.items[j].uid); if (k >= 0) { idx = k + 1; break; } }
    items.splice(idx, 0, it);
    ids.add(it.uid);
  });
  const out = { ...cur, ...m, items: items.length ? items : [blankItem()] };
  LIVE_HEAD.forEach((k) => { if (norm(k, cur[k]) === norm(k, m[k])) out[k] = cur[k]; });
  return out;
}
